import { render } from "./mainFace.vue?vue&type=template&id=0c644f2a"
import script from "./mainFace.vue?vue&type=script&lang=js"
export * from "./mainFace.vue?vue&type=script&lang=js"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__